import { WSList } from "@wingspanhq/fe-component-library";
import { useRouteMatch } from "react-router-dom";
import { FlowAddPayoutMethod } from "../../Settings/components/payout/FlowAddPayoutMethod";
import { CardPayoutMethodRequirementRequester } from "../components/CardPayoutMethodRequirementRequester";
import { useOnboardignModules } from "../Context";
import {
  OnboardingModuleCreateAccount,
  OnboardingModulePayoutMethod
} from "../types";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const PayoutMethod: React.FC<FlowStep> = ({ onNext }) => {
  const match = useRouteMatch();
  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "payout_method") as
    | OnboardingModulePayoutMethod
    | undefined;

  // When the integrator pinned a country on the create_account module, the
  // country is pre-filled from the contractor's profile — lock it here so it
  // can't be changed to a value that conflicts with the pinned country.
  const createAccountModule = modules.find(m => m.type === "create_account") as
    | OnboardingModuleCreateAccount
    | undefined;
  const lockCountry = !!createAccountModule?.options?.country;

  return (
    <WSList gap="2XL">
      <CardPayoutMethodRequirementRequester />

      <FlowAddPayoutMethod
        basePath={match.path}
        onNext={onNext}
        availableUsMethods={onboardingModule?.allowedUsMethods}
        availableInternationalMethods={
          onboardingModule?.allowedInternationalMethods
        }
        localCurrencyOnly={onboardingModule?.localCurrencyOnly}
        lockCountry={lockCountry}
      />
    </WSList>
  );
};
